import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import CustomerApp from "./CustomerApp";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalInstance";
import "./index.css";

async function bootstrap() {
  try {
    await msalInstance.initialize();
    const rootElement = document.getElementById("root");
    if (!rootElement) throw new Error("Root element #root niet gevonden");
    // Local development always runs the customer portal on :3000 and Admin on
    // :5173. This runtime rule is intentionally based on the port, not CRA's
    // build-time environment, so a stale or shared dev bundle cannot show the
    // Admin portal on the customer URL.
    const PortalApp = process.env.NODE_ENV === "development"
      ? window.location.port === "3000" ? CustomerApp : App
      : process.env.REACT_APP_PORTAL_MODE === "customer" ? CustomerApp : App;
    ReactDOM.createRoot(rootElement).render(<MsalProvider instance={msalInstance}><PortalApp /></MsalProvider>);
  } catch (err) {
    const rootElement = document.getElementById("root");
    if (rootElement) rootElement.innerHTML = `<pre style="padding:16px;color:red;">Bootstrap fout: ${err instanceof Error ? err.message : String(err)}</pre>`;
  }
}

bootstrap();
